import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useCliente } from "../context/ClienteContext";
import axios from "axios";
import "../styles/CadastroUsuario.css";
import "../styles/global.css";

const DetalhesTurma = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { parametros } = useCliente();
  
  const [turma, setTurma] = useState(null);
  const [cursoNome, setCursoNome] = useState("");
  const [cursoCodigo, setCursoCodigo] = useState("");
  const [coordenadorNome, setCoordenadorNome] = useState("");
  const [coordenadorEmail, setCoordenadorEmail] = useState("");
  const [cursoModalidade, setCursoModalidade] = useState("");
  const [escalasProfessores, setEscalasProfessores] = useState({});
  const [modoEdicao, setModoEdicao] = useState(false);
  const [opcoesProfessores, setOpcoesProfessores] = useState({});
  const [mapaIdParaNomeProfessor, setMapaIdParaNomeProfessor] = useState({});


  useEffect(() => {
    const fetchDados = async () => {
      try {
        const response = await axios.get(`/api/turmas/${id}`);
        setTurma(response.data);
        setCursoCodigo(response.data?.curso_codigo || '-');
        setCursoNome(response.data?.curso_nome || '-');
        setCoordenadorNome(response.data?.coordenador_nome || '-');
        setCoordenadorEmail(response.data?.coordenador_email || '-');
        setCursoModalidade(response.data?.curso_modalidade || '-');

        const novoMapa = {};
        if (response.data?.escalas_professores) {
          response.data.escalas_professores.forEach((escala) => {
            if (escala.disciplina_id) {
              novoMapa[escala.disciplina_id] = escala.professor_id; // professor_id pode ser null
            }
          });
        }
        setEscalasProfessores(novoMapa);
  
        const mapaNome = {};
        if (response.data?.escalas_professores) {
          response.data.escalas_professores.forEach((escala) => {
            if (escala.professor_nome && escala.professor_id) {
              mapaNome[escala.professor_id] = escala.professor_nome;
            }
          });
        }
        setMapaIdParaNomeProfessor(mapaNome);
  
        console.log("🎯 Escalas Professores carregadas:", novoMapa);
        console.log("🎯 Mapa ID para Nome carregado:", mapaNome);
  
      } catch (error) {
        console.error("Erro ao buscar dados da turma:", error);
      }
    };
  
    fetchDados();
    carregarTodosProfessores();
  }, [id]);
  

  const handleExcluirTurma = async () => {
    if (window.confirm("Tem certeza que deseja excluir esta turma?")) {
      try {
        const usuario_id = localStorage.getItem("user_id");
        await axios.delete(`/api/turmas/${id}?usuario_id=${usuario_id}`);
        alert("Turma excluída com sucesso!");
        navigate("/turmas");
      } catch (error) {
        console.error("Erro ao excluir turma:", error);
        alert("Erro ao excluir a turma. Tente novamente.");
      }
    }
  };
  

  const handleEscalarProfessores = async () => {
    setModoEdicao(true);
    try {
      const clienteId = localStorage.getItem("cliente_id");
  
      const novoMapa = {};
  
      for (const disciplina of turma.disciplinas_curso) {
        const response = await axios.get(`/api/usuarios/professores?cliente_id=${clienteId}&disciplina_id=${disciplina.id}`);
        const professores = response.data;
        novoMapa[disciplina.id] = professores;
      }
  
      setOpcoesProfessores(novoMapa);
    } catch (error) {
      console.error("Erro ao buscar professores:", error);
      alert("Erro ao buscar professores disponíveis.");
    }
  };
  

  const handleChangeProfessor = (disciplinaId, professorId) => {
    setEscalasProfessores((prev) => ({
      ...prev,
      [disciplinaId]: professorId
    }));
  };
  
  
  const handleSalvarEscala = async () => {
    try {
      const turmaId = id; // ID da turma atual
      const clienteId = localStorage.getItem("cliente_id");
  
      const payload = Object.entries(escalasProfessores).map(([disciplinaId, professorId]) => ({
        disciplina_id: parseInt(disciplinaId),
        professor_id: professorId ? parseInt(professorId) : null, // 🔵 Se não selecionar professor, salva como null
        turma_id: turmaId,
        cliente_id: clienteId
      }));
  
      await axios.post("/api/escala_professor_turma", payload);
  
      // 🔵 Após salvar, recarrega dados da turma e escalas
      const response = await axios.get(`/api/turmas/${turmaId}`);
      setTurma(response.data);
      setCursoCodigo(response.data?.curso?.codigo || '-');
      setCursoNome(response.data?.curso?.nome || '-');
      setCoordenadorNome(response.data?.coordenador?.nome_completo || '-');
      setCoordenadorEmail(response.data?.coordenador?.email || '-');

  
      // 🔵 Reconstrói mapa de escalas atualizado
      const novoMapa = {};
      if (response.data?.escalas_professores) {
        response.data.escalas_professores.forEach((escala) => {
          if (escala.disciplina_id) {
            novoMapa[escala.disciplina_id] = escala.professor_id;
          }
        });
      }
      setEscalasProfessores(novoMapa);
  
      setModoEdicao(false);
      alert("Escala de professores salva com sucesso!");
    } catch (error) {
      console.error("Erro ao salvar escala:", error);
      alert("Erro ao salvar escala.");
    }
  };
  
  const nomeProfessorEscalado = (disciplinaId) => {
    const professorId = escalasProfessores[disciplinaId];
    if (!professorId) return "A definir";
  
    const nomeDireto = mapaIdParaNomeProfessor[professorId];
    if (nomeDireto) return nomeDireto;
  
    return "A definir";
  };
  
  
  const nomeDoProfessorPorId = (professorId) => {
    if (!professorId) return null;
  
    for (const listaProfessores of Object.values(opcoesProfessores)) {
      const professorEncontrado = listaProfessores.find((prof) => prof.id === professorId);
      if (professorEncontrado) {
        return professorEncontrado.nome_completo;
      }
    }
    return null;
  };
  
  const carregarTodosProfessores = async () => {
    try {
      const clienteId = localStorage.getItem("cliente_id");
      const response = await axios.get(`/api/usuarios/professores?cliente_id=${clienteId}`);
      const todosProfessores = response.data || [];
  
      // Atualiza opcoesProfessores para o DetalhesTurma poder encontrar nomes
      const mapa = {};
      for (const professor of todosProfessores) {
        mapa[professor.id] = professor.nome_completo;
      }
      console.log("📚 Mapa ID → Nome dos Professores:", mapa);

      setMapaIdParaNomeProfessor(mapa);
    } catch (error) {
      console.error("Erro ao carregar professores:", error);
    }
  };
  

  if (!turma) {
    return <div className="form-wrapper">Carregando detalhes da turma...</div>;
  }

  const userId = localStorage.getItem("user_id");
  const disciplinasDoProfessor = turma?.disciplinas_curso?.filter(
    (disciplina) => escalasProfessores[disciplina.id] == userId
  ) || [];

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Detalhes da Turma</h2>

      {/* Dados Básicos */}
      <div className="form-row">
        <div className="form-group" style={{ width: "200px", flex: "none" }}>
          <label>Cód. da Turma</label>
          <div className="campo-detalhe">{turma.codigo}</div>
        </div>

        <div className="form-group">
          <label>Nome da Turma</label>
          <div className="campo-detalhe">{turma.nome}</div>
        </div>
      </div>

      <div className="form-row">
        <div className="form-group" style={{ width: "200px", flex: "none" }}>
          <label>Cód. do Curso</label>
          <div className="campo-detalhe">{cursoCodigo}</div>
        </div>

        <div className="form-group">
          <label>Nome do Curso</label>
          <div className="campo-detalhe">{cursoNome}</div>
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Coordenador</label>
          <div className="campo-detalhe">{coordenadorNome}</div>
        </div>

        <div className="form-group">
          <label>E-mail do Coordenador</label>
          <div className="campo-detalhe">
            <a href={`mailto:${coordenadorEmail}`} target="_blank" rel="noopener noreferrer">
              {coordenadorEmail}
            </a>
          </div>
        </div>
      </div>

      <div className="form-row">
        <div className="form-group" style={{ width: "220px", flex: "none" }}>
          <label>Modalidade do Curso</label>
          <div className="campo-detalhe">{cursoModalidade}</div>
        </div>

        <div className="form-group" style={{ width: "220px", flex: "none" }}>
          <label>Data de Início</label>
          <div className="campo-detalhe">
            {turma.data_inicio ? new Date(turma.data_inicio).toLocaleDateString() : ""}
          </div>
        </div>

        <div className="form-group" style={{ width: "220px", flex: "none" }}>
          <label>Data de Término</label>
          <div className="campo-detalhe">
            {turma.data_termino ? new Date(turma.data_termino).toLocaleDateString() : ""}
          </div>
        </div>
      </div>

      {/* 📚 Tabela de Disciplinas */}
      <div className="form-group full-width">
        <label>Disciplinas do Curso</label>


  {turma?.disciplinas_curso?.length > 0 ? (
    <table className="tabela" style={{ fontSize: "0.75rem", marginTop: "10px" }}>
      <thead
        style={{
          backgroundColor: parametros?.cor_cabecalho || "#156082",
          color: "white",
        }}
      >
        <tr>
          <th style={{ textAlign: "left", width: "20%" }}>Código</th>
          <th style={{ textAlign: "left", width: "50%" }}>Nome</th>
          <th style={{ textAlign: "left", width: "30%" }}>Ação</th>
        </tr>
      </thead>
      <tbody>
        {disciplinasDoProfessor.map((disciplina, index) => (
          <tr key={index}>
            <td style={{ padding: "4px 8px" }}>{disciplina.codigo}</td>
            <td style={{ padding: "4px 8px" }}>{disciplina.nome}</td>
            <td style={{ padding: "4px 8px" }}>

            <button
              className="btn btn-primary"
              onClick={() => navigate(`/publicar-checkpoint2/${disciplina.id}/${id}`)}
            >
              Checkpoint
            </button>



            </td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <p style={{ marginTop: "10px" }}>Nenhuma disciplina vinculada ao curso.</p>
  )}
  </div> {/* 🔵 Fecha aqui a form-group full-width */}
                       

      {/* Botões */}
      <div className="form-actions">
        <button
          className="btn btn-secondary"
          onClick={() => navigate("/turmas")}
        >
          Voltar
        </button>
        {!["coordenador", "professor"].includes(localStorage.getItem("tipo")) && (
        <button
          className="btn btn-primary"
          onClick={() => navigate(`/editar-turma/${id}`)}
        >
          Editar Turma
        </button>
        )}

        {!modoEdicao && localStorage.getItem("tipo") !== "professor" && (
          <button
            className="btn btn-primary"
            onClick={handleEscalarProfessores}
          >
            Escalar Professores
          </button>
        )}

        
        {modoEdicao && (
          <button
            className="btn btn-primary"
            style={{ marginLeft: "10px" }}
            onClick={handleSalvarEscala}
          >
            Salvar Escala
          </button>
        )}
        {!["coordenador", "professor"].includes(localStorage.getItem("tipo")) && (
        <button
          className="btn btn-danger"
          onClick={handleExcluirTurma}
        >
          Excluir Turma
        </button>
        )}

      </div>
    </div>
  );
};

export default DetalhesTurma;
